import React from 'react'

const Button = React.memo(
  ({
    type = 'button',
    onClick,
    children = 'Button',
    className = '',
    style = {},
    isDisable = false,
    ...rest
  }) => {
    return (
      <button
        type={type}
        onClick={onClick}
        disabled={isDisable}
        className={`bg-[#00811D] group relative w-full flex space-x-4 justify-center py-2 px-4  text-[16px] font-[500] rounded-md text-[#FFFFFF] hover:scale-95 transition-all duration-300 ease-in-out ${className}`}
        {...rest}
      >
        {' '}
        {children}
      </button>
    )
  }
)

export default Button
